import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { ICreateCommentFormData, ICreateCommentResponse } from "./types";

export const createComment = async (newComment: ICreateCommentFormData): Promise<ICreateCommentResponse> => {
  try {
    const response = await apiClientSource.post(`/task-service/api/comments`, newComment);
    return response.data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el comentario de la tarea");
    throw error;
  }
}